import Loading from "../../../loaders/LoaderSpinner.tsx";

export default function ErrorFlow({
        onBack,
        onSubmit,
        loading,
    }: {
    onBack: () => void
    onSubmit: () => void
    loading: boolean
}) {
    if (loading) {
        return <Loading/>
    }

    return (
        <div className={'navigation-buttons'}>
            <button className={'button gray'} onClick={onBack}>
                Tilbage
            </button>
            <button className={'button teal'} onClick={onSubmit}>
                Send til support
            </button>
        </div>
    );
}
